'use client';

import React from 'react';

export default function SiteContact() {
  return (
    <section id="contato" className="py-xl bg-surface">
      <div className="max-w-7xl mx-auto px-lg">
        <div className="bg-white rounded-[40px] ambient-shadow overflow-hidden flex flex-col lg:flex-row border border-outline-variant/10">
          {/* Contact Info */}
          <div className="lg:w-1/3 p-xl bg-surface-container-low/50 flex flex-col justify-center">
            <span className="text-label-caps text-primary tracking-[0.2em] font-bold mb-md">CONTATO</span>
            <h2 className="text-h2 text-on-surface mb-md">Visite o Ateliê</h2>
            <p className="text-body-md text-secondary mb-xl">Agende seu horário para uma experiência personalizada e exclusiva.</p>
            
            <div className="space-y-lg mb-xl">
              <div className="flex items-start gap-md group">
                <div className="w-10 h-10 rounded-xl bg-white flex items-center justify-center text-primary shadow-sm group-hover:bg-primary group-hover:text-white transition-all">
                  <span className="material-symbols-outlined">location_on</span>
                </div>
                <div>
                  <h4 className="text-label-caps text-[10px] text-on-surface mb-xs font-black">ENDEREÇO</h4>
                  <p className="text-sm text-secondary leading-relaxed">
                    Rua Américo Curvelo, 253, Loja C<br/>Bairro Salgado Filho, Aracaju - SE
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-md group">
                <div className="w-10 h-10 rounded-xl bg-white flex items-center justify-center text-primary shadow-sm group-hover:bg-primary group-hover:text-white transition-all">
                  <span className="material-symbols-outlined">schedule</span>
                </div>
                <div>
                  <h4 className="text-label-caps text-[10px] text-on-surface mb-xs font-black">ATENDIMENTO</h4>
                  <p className="text-sm text-secondary leading-relaxed">
                    Seg a Sex: 09h às 18h<br/>Sáb: 09h às 13h (Com agendamento)
                  </p>
                </div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-md">
              <a 
                href="https://wa.me/5579988086893" 
                target="_blank"
                className="flex-1 py-md bg-[#25D366] text-white font-button text-button rounded-xl flex items-center justify-center gap-sm hover:brightness-110 transition-all shadow-md"
              >
                <svg className="w-5 h-5 fill-current" viewBox="0 0 24 24">
                  <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L0 24l6.335-1.662c1.72.937 3.659 1.432 5.631 1.433h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" />
                </svg>
                WhatsApp
              </a>
              <a 
                href="https://www.instagram.com/elizatelieoficial/"
                target="_blank"
                className="flex-1 py-md border border-outline-variant/30 text-on-surface font-button text-button rounded-xl flex items-center justify-center gap-sm hover:bg-surface-container-low transition-all"
              >
                <svg className="w-5 h-5 fill-current" viewBox="0 0 24 24">
                  <path d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.984 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.335.935 20.665.522 19.875.217c-.765-.295-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.584.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.584-.071 4.85c-.055 1.17-.249 1.805-.415 2.227-.217.562-.477.96-.896 1.382-.42.419-.819.679-1.381.896-.422.164-1.057.36-2.227.413-1.266.057-1.646.07-4.85.07s-3.584-.015-4.85-.071c-1.17-.055-1.805-.249-2.227-.415-.562-.217-.96-.477-1.382-.896-.419-.42-.679-.819-.896-1.381-.164-.422-.36-1.057-.413-2.227-.057-1.266-.07-1.646-.07-4.85s.015-3.584.071-4.85c.055-1.17.249-1.805.415-2.227.217-.562.477-.96.896-1.382.42-.419.819-.679 1.381-.896.422-.164 1.057-.36 2.227-.413 1.266-.057 1.646-.07 4.85-.07zM12 5.837a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
                </svg>
                Instagram
              </a>
            </div>
          </div>

          {/* Map Visual */}
          <div className="lg:w-2/3 h-[400px] lg:h-auto relative bg-surface-container-high overflow-hidden">
            <iframe 
              width="100%" 
              height="100%" 
              frameBorder="0" 
              scrolling="no" 
              marginHeight={0} 
              marginWidth={0} 
              src="https://maps.google.com/maps?q=Rua%20Am%C3%A9rico%20Curvelo,%20253%20Salgado%20Filho%20Aracaju%20SE&t=&z=17&ie=UTF8&iwloc=&output=embed"
              className="grayscale opacity-80 contrast-125 hover:grayscale-0 hover:opacity-100 transition-all duration-700"
            />
            
            {/* Minimal Address Card on Map */}
            <div className="absolute bottom-md right-md glass-panel p-md rounded-2xl ambient-shadow border border-white/50 max-w-[240px] hidden md:block pointer-events-none">
              <p className="text-xs font-bold text-on-surface mb-1">Eliz Ateliê - Studio</p>
              <p className="text-[10px] text-secondary leading-snug">Salgado Filho, Aracaju. Próximo à Praça da Imprensa.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
